import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { RoomService } from 'libs/admin/room/src/lib/services/room.service';
import { flatMap } from 'lodash';
import { OverlayPanel } from 'primeng/overlaypanel';

@Component({
  selector: 'hospitality-bot-info-panel',
  templateUrl: './info-panel.component.html',
  styleUrls: ['./info-panel.component.scss'],
  providers: [RoomService],
})
export class InfoPanelComponent implements OnInit {
  showContent: boolean = false;

  @Input() type: 'booking' | 'room' | 'housekeeping' = 'room';
  title: string = 'Room Status';
  features = [];
  @ViewChild('overlay') overlay: OverlayPanel;

  constructor(private roomService: RoomService) {
    this.getDefaultFeatures();
  }

  bookingStatus = [
    {
      name: 'Check-out',
      color: '#ef1d45',
    },
    {
      name: 'Due-in',
      color: '#52b33f',
    },
    {
      name: 'Check-In',
      color: '#3166f0',
    },
    {
      name: 'Due-Out',
      color: '#550000',
    },
    {
      name: 'Out of Service',
      color: '#555555',
    },
    {
      name: 'Out of Order',
      color: 'rgba(85, 85, 85, 0.1',
    },
  ];

  roomStatus = [
    {
      name: 'Occupied',
      color: '#ef1d45',
    },
    {
      name: 'Vacant',
      color: '#52b33f',
    },
    {
      name: 'Clean',
      color: 'rgb(49, 102, 240)',
    },
    {
      name: 'Due Out',
      color: '#500',
    },
    {
      name: 'Dirty',
      color: '#ff8f00',
    },
  ];

  bookingIndicator = [
    {
      name: 'Day Booking',
      icon: 'assets/images/day-booking.svg',
    },
    {
      name: 'Group Booking',
      icon: 'assets/images/group-booking.svg',
    },
    {
      name: 'Single Lady',
      icon: 'assets/images/signle-lady.svg',
    },
    {
      name: 'VIP',
      icon: 'assets/images/VIP.svg',
    },
    {
      name: 'Payment Pending',
      icon: 'assets/images/payment-pending.svg',
    },
  ];

  ngOnChanges() {
    if (this.type === 'booking') {
      this.title = 'Booking Status';
      this.roomStatus = this.bookingStatus;
    } else if (this.type === 'housekeeping') {
      this.title = 'Room Status';
      this.bookingIndicator = [];
    }
  }

  ngOnInit(): void {}

  getDefaultFeatures() {
    this.roomService.getFeatures().subscribe((res) => {
      this.features = res.features.map((feature) => {
        return {
          name: feature.name,
          icon: feature.imageUrl[0].url,
        };
      });
    });
  }

  handleOnMouseEnter(event: MouseEvent): void {
    this.addGlobalCss(true);
    this.overlay.show(event);
    this.subscribeToMouseEvents();
  }

  subscribeToMouseEvents() {
    //This code will hide the overlay if the current mouse position is outside the overlay; otherwise, it will display the overlay
    const layoutElement = document.getElementById('main-layout');

    layoutElement.addEventListener('mouseover', (event: MouseEvent) => {
      event.stopPropagation();

      const isInsideContainer = this.isEventInsideContainer(event);
      if (isInsideContainer) {
        return;
      }

      this.addGlobalCss(false);
      this.overlay.hide();
      layoutElement.removeEventListener('mouseover', () => {});
    });
  }

  private isEventInsideContainer(event: MouseEvent): boolean {
    return this.overlay.el.nativeElement.contains(event.target);
  }

  addGlobalCss(condition: boolean) {
    condition
      ? document.documentElement.classList.add('my-global-class')
      : document.documentElement.classList.remove('my-global-class');
  }
}
